/**
 * knitData.js — Exact copies of every dropdown list in Knit's employee
 * payroll profile, transcribed from the Knit UI so the portal behaves
 * identically when employee settings are copied over.
 */

export const YES_NO = ["Yes", "No"];

export const SEX_OPTS = ["Female", "Male", "Other"];

export const SHIRT_OPTS = ["XS", "Small", "Medium", "Large", "XL", "2XL", "3XL"];

export const DEPENDENTS_OPTS = ["Yes", "No"];

export const PROVINCES = [
  "Alberta", "British Columbia", "Manitoba", "New Brunswick",
  "Newfoundland and Labrador", "Northwest Territories", "Nova Scotia",
  "Nunavut", "Ontario", "Prince Edward Island", "Quebec", "Saskatchewan",
  "Yukon",
];

export const COUNTRIES = [
  "Afghanistan", "Albania", "Algeria", "Andorra", "Angola",
  "Antigua and Barbuda", "Argentina", "Armenia", "Australia", "Austria",
  "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus",
  "Belgium", "Belize", "Benin", "Bhutan", "Bolivia",
  "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria",
  "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Canada",
  "Cape Verde", "Cayman Islands", "Central African Republic", "Chad",
  "Chile", "China", "Colombia", "Comoros", "Congo", "Costa Rica",
  "Croatia", "Cuba", "Cyprus", "Czech Republic",
  "Democratic Republic of the Congo", "Denmark", "Djibouti", "Dominica",
  "Dominican Republic", "Ecuador", "Egypt", "El Salvador",
  "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia",
  "Fiji", "Finland", "France", "Gabon", "Gambia", "Georgia", "Germany",
  "Ghana", "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau",
  "Guyana", "Haiti", "Honduras", "Hong Kong", "Hungary", "Iceland",
  "India", "Indonesia", "Iran", "Iraq", "Ireland", "Israel", "Italy",
  "Ivory Coast", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya",
  "Kiribati", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon",
  "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania",
  "Luxembourg", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali",
  "Malta", "Marshall Islands", "Mauritania", "Mauritius", "Mexico",
  "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco",
  "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands",
  "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Korea",
  "North Macedonia", "Norway", "Oman", "Pakistan", "Palau", "Palestine",
  "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines",
  "Poland", "Portugal", "Qatar", "Romania", "Russia", "Rwanda",
  "Saint Kitts and Nevis", "Saint Lucia",
  "Saint Vincent and the Grenadines", "Samoa", "San Marino",
  "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia",
  "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia",
  "Solomon Islands", "Somalia", "South Africa", "South Korea",
  "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden",
  "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand",
  "Timor-Leste", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia",
  "Turkey", "Turkmenistan", "Tuvalu", "Uganda", "Ukraine",
  "United Arab Emirates", "United Kingdom", "United States", "Uruguay",
  "Uzbekistan", "Vanuatu", "Vatican City", "Venezuela", "Vietnam",
  "Yemen", "Zambia", "Zimbabwe",
];

/** Canadian financial institutions — exact Knit Institution Number list. */
export const BANKS = [
  "(001) Bank of Montreal",
  "(002) Bank of Nova Scotia",
  "(003) Royal Bank of Canada",
  "(004) Toronto-Dominion Bank",
  "(006) National Bank of Canada",
  "(010) Canadian Imperial Bank of Commerce/Simplii Financial",
  "(016) HSBC Canada",
  "(030) Canadian Western Bank",
  "(039) Laurentian Bank of Canada",
  "(117) Government of Canada",
  "(127) Canada Post",
  "(177) Bank of Canada",
  "(219) ATB Financial",
  "(241) Bank of America",
  "(260) Citibank",
  "(270) JPMorgan Chase Bank",
  "(275) Korea Exchange Bank of Canada",
  "(290) UBS Bank",
  "(294) State Bank of India",
  "(308) Bank of China",
  "(309) Citizens Bank of Canada",
  "(310) First Nations Bank",
  "(320) President's Choice Bank",
  "(326) President's Choice Financial",
  "(328) Citibank NA",
  "(338) Canadian Tire Bank",
  "(340) ICICI Bank",
  "(352) Directcash Bank",
  "(355) Shinhan Bank Canada",
  "(374) Motus Bank",
  "(383) Peoples Bank of Canada",
  "(509) Canada Trust",
  "(540) Manulife Bank",
  "(568) Peace Hills Trust Company",
  "(608) CS Alterna Bank",
  "(614) Tangerine/ING Direct Canada",
  "(621) Peoples Trust Company",
  "(623) Equitable Bank",
  "(703) Wealthsimple Investments Inc.",
  "(705) Wise Payments Canada Inc.",
  "(809) Interior Savings Credit Union",
  "(809) Central 1 Credit Union",
  "(809) Coastal Community Credit Union",
  "(809) First Credit Union",
  "(809) Nelson District Credit Union",
  "(809) Vancity Credit Union",
  "(809) Northern Savings Credit Union",
  "(809) Coast Capital Savings",
  "(809) Credit Union Central of British Columbia",
  "(815) La Confédération des Caisses Populaires et D'Économie Desjardins du Québec",
  "(819) Caisses populaires Desjardins du Manitoba",
  "(828) DUCA Financial Services Credit Union",
  "(828) Credit Union Central of Ontario Limited",
  "(828) Libro Credit Union",
  "(828) Kawartha Credit Union",
  "(828) Mennonite Savings and Credit Union",
  "(828) Your Neighbourhood Credit Union Ltd",
  "(828) Windsor Family Credit Union",
  "(829) La Fédération des Caisses Populaires de l'Ontario Inc.",
  "(837) Meridian Credit Union",
  "(839) Atlantic Central",
  "(839) Credit Union Heritage",
  "(842) Alterna Savings Credit Union",
  "(849) Beaubear Credit Union Ltd.",
  "(851) Credit Unions In Ontario",
  "(853) Concentra Financial Services Assoc.",
  "(859) Federation Des Caisses Populaires De L'ontario",
  "(865) La Fédération des Caisses Populaires Acadiennes Limitée",
  "(879) Steinbach Credit Union",
  "(879) Credit Union Central of Manitoba",
  "(879) Assiniboine Credit Union",
  "(879) Crosstown Civic Credit Union",
  "(889) Credit Union Central of Saskatchewan",
  "(889) Affinity Credit Union",
  "(890) Alliance des caisses populaires de l'ontario",
  "(899) Servus Credit Union",
  "(899) Credit Union Central Alberta",
];

export const ACCOUNT_TYPES = ["Checking", "Saving"];

/** 2026 Federal TD1 claim codes (claim amount = upper bound of range). */
export const FEDERAL_TD1_CODES = [
  "Code 0 ($0.00 to $0.00)",
  "Code 1 ($0.00 to $16,452.00)",
  "Code 2 ($16,452.01 to $19,285.00)",
  "Code 3 ($19,285.01 to $22,118.00)",
  "Code 4 ($22,118.01 to $24,951.00)",
  "Code 5 ($24,951.01 to $27,784.00)",
  "Code 6 ($27,784.01 to $30,617.00)",
  "Code 7 ($30,617.01 to $33,450.00)",
  "Code 8 ($33,450.01 to $36,283.00)",
  "Code 9 ($36,283.01 to $39,116.00)",
  "Code 10 ($39,116.01 to $41,949.00)",
];

/** 2026 Ontario TD1P claim codes. */
export const PROVINCIAL_TD1_CODES = [
  "Code 0 ($0.00 to $0.00)",
  "Code 1 ($0.00 to $12,989.00)",
  "Code 2 ($12,989.01 to $15,787.00)",
  "Code 3 ($15,787.01 to $18,585.00)",
  "Code 4 ($18,585.01 to $21,383.00)",
  "Code 5 ($21,383.01 to $24,181.00)",
  "Code 6 ($24,181.01 to $26,979.00)",
  "Code 7 ($26,979.01 to $29,777.00)",
  "Code 8 ($29,777.01 to $32,575.00)",
  "Code 9 ($32,575.01 to $35,373.00)",
  "Code 10 ($35,373.01 to $38,171.00)",
];

/** T4 Box 45 — dental benefit reporting codes. */
export const T4_BOX45_CODES = [
  "Code 1 (Not eligible)",
  "Code 2 (Payee only)",
  "Code 3 (Payee, spouse and dependent children)",
  "Code 4 (Payee and their spouse)",
  "Code 5 (Payee and their dependent children)",
];

export const EMPLOYEE_TYPES = ["Full time", "Part time", "Intern", "Contractor"];

export const EMPLOYEE_TYPE_OPTIONS = ["Hourly", "Salaried"];

export const WAGE_PER_OPTIONS = ["Year", "Month", "Week", "Hour"];

export const PAYGROUPS = ["Weekly"];

export const PAYMENT_FREQUENCIES = ["Weekly"];

export const VACATION_PAYMENT_OPTIONS = [
  "Lump sum at end of calendar year",
  "Lump sum at end of work anniversary",
  "Accrue until payout",
  "Paid on each pay check",
];

export const WORK_LOCATIONS = ["Office", "In The Field"];

/** Location list on the Pay Rate editor (Knit includes WSIB Exempt). */
export const PAY_RATE_LOCATIONS = ["Office", "In The Field", "WSIB Exempt"];

export const WCB_LOCATIONS = ["Same as work location", ...WORK_LOCATIONS];

export const DEPARTMENTS = ["In The Field", "Office"];

export const RECURRING_INCOME_TYPES = [
  "Automobile Benefit", "Holiday Pay", "Time Worked on Holiday", "Overtime",
  "Reimbursement", "Vacation Pay", "Regular Pay", "Bonus",
];

/** Income types whose "amount" is a number of HOURS (paid at the wage). */
export const HOURS_BASED_INCOMES = ["Regular Pay", "Overtime", "Time Worked on Holiday"];

/** Reimbursement is non-payable: added to the pay amount, never taxed. */
export const NON_TAXED_INCOMES = ["Reimbursement"];

export const RECURRING_DEDUCTION_TYPES = [
  "Balance Reconciliation", "CRA Repayment", "Advance Repayment",
];

/** Record of Employment — Block 16 reason list (exact Knit/EI list). */
export const ROE_REASONS = [
  "Shortage of work / End of Contract or Season",
  "Employer bankruptcy or receivership",
  "Strike or lockout",
  "Illness or injury",
  "Quit",
  "Quit / Follow spouse",
  "Quit / Return to school",
  "Quit / Health reasons",
  "Quit / Voluntary retirement",
  "Quit / Take another job",
  "Quit / Employer relocation",
  "Quit / Care for a dependant",
  "Quit / To become self-employed",
  "Maternity",
  "Mandatory retirement",
  "Retirement / Approved workforce reduction",
  "Work sharing",
  "Apprentice training",
  "Other",
  "Other / Change of payroll frequency",
  "Other / Change of ownership",
  "Other / Requested by Employment Insurance",
  "Other / Canadian Forces - Queen's Regulations/Orders",
  "Other / At the employee's request",
  "Other / Change of Service Provider",
  "Dismissal",
  "Dismissal / Terminated within probationary period",
  "Leave of absence",
  "Parental",
  "Compassionate care",
];

export const EXPECTED_TO_RECALL = ["Unknown", "Not returning", "Return"];

export const PAY_PERIOD_TYPES = [
  "Bi-weekly", "Monthly", "Monthly non-standard", "Semi-monthly",
  "Semi-monthly non-standard", "Thirteen Pay Periods per year", "Weekly",
];

export const LANGUAGES = ["English", "French"];

export const PTO_STATUSES = ["Pending", "Approved", "Denied", "Cancelled"];

/** Pull the numeric claim amount out of a TD1 code label
 *  ("Code 1 ($0.00 to $16,452.00)" → 16452). */
export const td1ClaimAmount = (label) => {
  const m = /to \$([\d,]+\.\d{2})\)/.exec(label || "");
  return m ? parseFloat(m[1].replace(/,/g, "")) : 0;
};
